    'use client';

import React, { useState } from 'react';
import { ThemeProvider } from 'next-themes';
// Import your AuthProvider etc.
import { AuthProvider } from './providers/AuthProvider';
import SessionProvider from './providers/SessionProvider'; // NextAuth wrapper
import { ClientToastWrapper } from './providers/ClientToastWrapper';
import { SessionContext } from '@/hooks/useSessionSimple';
import { getAuthHeaders } from '@/lib/authService'; // Import the real auth function
import { CountryProvider } from '@/contexts/CountryContext';

// Simplified SessionProvider that provides the interface expected by useSession
function SimpleSessionProvider({ children }: { children: React.ReactNode }) {
  const [backendSessionId, setBackendSessionId] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);
  const [isReady, setIsReady] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const value = {
    backendSessionId,
    user,
    setUserSession: setUser,
    setBackendSessionId,
    clearSession: () => {
      setUser(null);
      setBackendSessionId(null);
    },
    isReady,
    isLoading,
    getAuthHeaders: () => getAuthHeaders(), // Use real auth service function
    userRole: user?.role || null,
  };

  return (
    <SessionContext.Provider value={value}>
      {children}
    </SessionContext.Provider>
  );
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <SimpleSessionProvider>
        <AuthProvider>
          <CountryProvider>
            <ThemeProvider
              attribute="class"
              defaultTheme="system"
              enableSystem
              disableTransitionOnChange
            >
              <ClientToastWrapper>
                {children}
              </ClientToastWrapper>
            </ThemeProvider>
          </CountryProvider>
        </AuthProvider>
      </SimpleSessionProvider>
    </SessionProvider>
  );
}